import { isProduction } from '..';
import type { AppConfig } from '../types';

export default {
  zone: 'asia-3',
  defaultLocale: 'th-TH',
  availableLocales: ['en-TH', 'th-TH'],
  timedBanners: {
    cookieConsent: {
      displayDates: {
        startDate: '2024-01-19T00:00:00.000Z',
      },
    },
  },
  zoneFeatures: {
    AUTO_SELECT_SPLIT_VIEW_FIRST_JOB: false,
    ENTRY_LEVEL_BADGE: true,
    HOMEPAGE_BANNER_TYPE: 'multiple-asia',
    HOMEPAGE_LHS_BANNER_TYPE: 'GENERIC_ASIA_BANNER',
    HOMEPAGE_RHS_BANNER_TYPE: 'MARKETING_BANNER_SEEK_PASS',
    JOBSEARCH_ASSIST: false,
    KEYWORD_AUTOSUGGEST_V2: true,
    LMIS_ENABLED: true,
    LOGGED_OUT_RECS: false,
    NUDGE_ENABLED: false,
    PDPA_CONSENT_REQUIRED: true,
    REMOTE_SEARCH_FILTER: true,
    REMOTE_SEARCH_FILTER_NEW_LABEL: true,
    SEARCH_PAGE_SIZE: 32,
    SERP_JOBCARD_INFO_DENSITY_1: false,
    SHOW_FLOATING_SAVE_SEARCH: false,
    SHOW_MARKETING_AD_SPLIT_VIEW: true,
  },
  BRANCH_IO_KEY: isProduction
    ? 'key_live_dgOh8Yali0X6D5LPpX679mjkuFnVPBnB'
    : 'key_test_baKe5Wbdl33XD3LQi6260idbvzfPPAfV',
  GPT_ACCOUNT_ID: '23209565015',
} as AppConfig;
